import { LoaderActions } from '@store/loaders'
import { call, put } from 'redux-saga/effects'

import { type ApiKey, ApiKeysService } from '@/services/apiKeys'
import { InternalApiKeysActions } from '../actions'

export function* fetchApiKeys() {
  yield put(LoaderActions.set('api_keys_fetch'))
  yield put(InternalApiKeysActions.setError(false))

  try {
    const keys: ApiKey[] = yield call(ApiKeysService.list)

    yield put(InternalApiKeysActions.set(keys))
  } catch (error) {
    console.error('Failed to load API keys', error)

    yield put(InternalApiKeysActions.setError(true))
  } finally {
    yield put(LoaderActions.unset('api_keys_fetch'))
  }
}
